import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { Action } from '../../actions';
import {
    addPhrasesGeneratorGroup,
    changePhrasesGeneratorPhrases,
    phrasesGeneratorGeneratePhrases,
    removePhrasesGeneratorGroup
} from '../../actions/phrases-selector/generator';
import {
    PhrasesSelectorGenerator,
    PhrasesSelectorGeneratorProps
} from '../../components/PhrasesSelector/PhrasesSelectorGenerator/PhrasesSelectorGenerator';
import { PHRASES_GENERATOR_MAX_PHRASES } from '../../constants';
import { selectPhrasesSelectorData } from '../../selectors/phrasesSelector/phrasesSelector';
import { getGeneratedPhrasesCount } from '../../service/PhrasesSelectorWizard/PhrasesSelectorWizard';
import { GroupId } from '../../typings/groups';
import { PhrasesSelectorGeneratorGroupPhrases, PhrasesSelectorWizardId } from '../../typings/phrases';
import { State } from '../../typings/state';
import { TDispatchProps, TStateProps } from '../../typings/utils';

export interface OwnProps {
    wizardId: PhrasesSelectorWizardId;
    groupId: GroupId;
    isExcludePhrases: boolean;
    onExcludePhrasesToggle: () => void;
}

type StateProps = TStateProps<PhrasesSelectorGeneratorProps, OwnProps>;

type DispatchProps = TDispatchProps<PhrasesSelectorGeneratorProps, OwnProps>;

const mapStateToProps = (state: State, ownProps: OwnProps): StateProps => {
    const [
        ,
        {
            generator: { groups }
        }
    ] = selectPhrasesSelectorData(state, ownProps.wizardId);
    const generatedPhrasesCount = getGeneratedPhrasesCount(groups);

    return {
        groups,
        generatedPhrasesCount,
        isGenerateDisabled: generatedPhrasesCount >= PHRASES_GENERATOR_MAX_PHRASES || generatedPhrasesCount === 0
    };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>, ownProps: OwnProps): DispatchProps => {
    const { wizardId, groupId } = ownProps;

    return {
        onGroupAdd() {
            dispatch(addPhrasesGeneratorGroup(groupId));
        },
        onGroupRemove(groupIndex: number) {
            dispatch(removePhrasesGeneratorGroup(groupId, groupIndex));
        },
        onGroupPhrasesChange(groupIndex: number, phrases: PhrasesSelectorGeneratorGroupPhrases) {
            dispatch(changePhrasesGeneratorPhrases(groupId, groupIndex, phrases));
        },
        onPhrasesGenerate() {
            dispatch(phrasesGeneratorGeneratePhrases(wizardId));
        }
    };
};

export const PhrasesSelectorGeneratorContainer = connect<StateProps, DispatchProps, OwnProps>(
    mapStateToProps,
    mapDispatchToProps
)(PhrasesSelectorGenerator);
